import { render } from "./distpatch.vue?vue&type=template&id=dc246d54"
import script from "./distpatch.vue?vue&type=script&lang=js"
export * from "./distpatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__